// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"94":"d0e5e37585012c85d9a7","236":"3dbf695a2ab22ca393e3","481":"329468a20bf58f6156d9","626":"0ea461cb0d6642fdacb9","882":"6618f0637d5ce25cac6c"}[chunkId] + ".js";
};